import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';

@Injectable({ providedIn: 'root' })

export class LoginApiService {
    public cdnUrl: string;
    constructor(private configService: ConfigService) { }
    
    guestUserLogin(user) {
        return this.configService.post("api/v2/oauth/guest", user);
    }

    getNewAccessToken(user) {
        var serializedParam = Object.keys(user).map(function (k) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(user[k]);
        }).join('&');
        return this.configService.post('api/v2/oauth/refresh', serializedParam, { 'Content-Type': 'application/x-www-form-urlencoded' });
    }

    logout() {
        return this.configService.post('api/v2/oauth/cancel/token', {})
    };
}